module.exports = __webpack_public_path__ + "static/4-a14a941c7a28fbacc8ef254c48445b19.png";